<div class="permissions-page" [attr.dir]="dir" (click)="closeAllMenus()">

  <header class="page-hero">
    <div class="page-hero__text">
      <h1 class="page-hero__title">{{ 'Permissions' | navTitle | async }}</h1>
      <p class="page-hero__subtitle">
        {{ dir === 'rtl'
          ? 'إدارة المستخدمين وصلاحياتهم، مع تصفية حسب الدور وعرض مرن.'
          : 'Manage users and their permissions, with role filters and flexible views.' }}
      </p>
    </div>
    <button type="button" class="btn-new-user" (click)="openUserModal(0)">
      <i class="fa-solid fa-user-plus"></i>
      <span>{{ 'new_user' | translate }}</span>
    </button>
  </header>

  <section class="stats-grid" aria-label="summary">
    <div class="stat-chip">
      <span class="stat-chip__value">{{ paginator?.total_records || users.length || 0 }}</span>
      <span class="stat-chip__label">{{ dir === 'rtl' ? 'المستخدمون' : 'Users' }}</span>
    </div>
    <div class="stat-chip">
      <span class="stat-chip__value">{{ roles.length || 0 }}</span>
      <span class="stat-chip__label">{{ dir === 'rtl' ? 'الأدوار' : 'Roles' }}</span>
    </div>
    <div class="stat-chip">
      <span class="stat-chip__value">{{ filteredUsers.length }}</span>
      <span class="stat-chip__label">{{ dir === 'rtl' ? 'في الصفحة' : 'On page' }}</span>
    </div>
    <div class="stat-chip">
      <span class="stat-chip__value">{{ getDepartmentsCount() }}</span>
      <span class="stat-chip__label">{{ dir === 'rtl' ? 'إدارات ظاهرة' : 'Departments shown' }}</span>
    </div>
  </section>

  <section class="toolbar-card">
    <div class="toolbar-grid">
      <div class="filter-field">
        <label class="filter-label">
          <i class="fa-solid fa-user-shield"></i>
          <span>{{ 'permission' | translate }}</span>
        </label>
        <p-dropdown
          [(ngModel)]="selectedPermission"
          [options]="roleOptions"
          optionLabel="label"
          optionValue="value"
          (onChange)="onRoleChange()"
          appendTo="body"
          panelStyleClass="filter-dropdown-panel"
          [placeholder]="'select_role' | translate"
          styleClass="modern-dropdown">
        </p-dropdown>
      </div>

      <div class="filter-field search-field">
        <label class="filter-label">
          <i class="fa-solid fa-magnifying-glass"></i>
          <span>{{ dir === 'rtl' ? 'بحث' : 'Search' }}</span>
        </label>
        <div class="search-wrapper">
          <i class="fa-solid fa-search search-icon"></i>
          <input
            type="search"
            class="search-input"
            [(ngModel)]="searchTerm"
            (input)="onSearch()"
            [placeholder]="dir === 'rtl' ? 'ابحث بالاسم أو اسم المستخدم...' : 'Search by name or username...'" />
          @if (searchTerm) {
            <button type="button" class="search-clear" (click)="clearSearch()">
              <i class="fa-solid fa-xmark"></i>
            </button>
          }
        </div>
      </div>

      <div class="view-toggles" role="group">
        <button type="button" class="view-btn" [class.active]="displayType === 'cards'" (click)="displayType='cards'">
          <i class="pi pi-th-large"></i>
          <span>{{ 'cards_view' | translate }}</span>
        </button>
        <button type="button" class="view-btn" [class.active]="displayType === 'list'" (click)="displayType='list'">
          <i class="pi pi-list"></i>
          <span>{{ 'list_view' | translate }}</span>
        </button>
      </div>
    </div>
  </section>

  @if (displayType === 'cards') {
    <section class="results-card">
      @if (!filteredUsers.length) {
        <div class="empty-state">
          <div class="empty-state__icon"><i class="fa-solid fa-users-slash"></i></div>
          <p class="empty-state__title">{{ dir === 'rtl' ? 'لا يوجد مستخدمون' : 'No users found' }}</p>
          <p class="empty-state__text">{{ dir === 'rtl' ? 'عدّل الفلتر أو أضف مستخدمًا جديدًا.' : 'Adjust filters or add a new user.' }}</p>
        </div>
      } @else {
        <div class="users-grid">
          @for (user of filteredUsers; track user.id; let i = $index) {
            <article class="user-card" (click)="$event.stopPropagation()">
              <div class="user-menu-container">
                <button type="button" class="menu-dots-btn" (click)="toggleMenu($event, user.id)">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </button>
                @if (activeMenuId === user.id) {
                  <div class="menu-dropdown" (click)="$event.stopPropagation()">
                    <button type="button" class="menu-item menu-edit" (click)="openUserModal(user.id); closeMenu()">
                      <i class="fa-solid fa-pen-to-square"></i>
                      <span>{{ 'edit' | translate }}</span>
                    </button>
                    <button type="button" class="menu-item menu-password" (click)="openPasswordModal(user.id); closeMenu()">
                      <i class="fa-solid fa-key"></i>
                      <span>{{ 'change_password' | translate }}</span>
                    </button>
                    <button type="button" class="menu-item menu-delete" (click)="openDeleteUserModal(user.id); closeMenu()">
                      <i class="fa-regular fa-trash-can"></i>
                      <span>{{ 'delete' | translate }}</span>
                    </button>
                  </div>
                }
              </div>

              <div class="user-card-header">
                <span class="user-avatar">{{ getInitials(user.name || user.username) }}</span>
                <div class="user-heading">
                  <h3 class="user-name">{{ user.name }}</h3>
                  <span class="role-badge">{{ dir === 'rtl' ? (user.roleData?.name_ar || user.role) : (user.roleData?.name_en || user.role) }}</span>
                </div>
              </div>

              <div class="user-card-body">
                <div class="user-info-item">
                  <i class="fa-solid fa-hashtag info-icon"></i>
                  <div class="info-content">
                    <span class="info-label">{{ 'user_username' | translate }}</span>
                    <span class="info-value">{{ user.username }}</span>
                  </div>
                </div>
                <div class="user-info-item">
                  <i class="fa-solid fa-user-tie info-icon"></i>
                  <div class="info-content">
                    <span class="info-label">{{ 'job_title' | translate }}</span>
                    <span class="info-value">{{ user.job_title || '—' }}</span>
                  </div>
                </div>
                <div class="user-info-item">
                  <i class="fa-solid fa-building info-icon"></i>
                  <div class="info-content">
                    <span class="info-label">{{ 'department' | translate }}</span>
                    <span class="info-value">{{ user.depData?.name || '—' }}</span>
                  </div>
                </div>
                <div class="user-info-item">
                  <i class="fa-solid fa-sitemap info-icon"></i>
                  <div class="info-content">
                    <span class="info-label">{{ 'section' | translate }}</span>
                    <span class="info-value">{{ user.sectionData?.name || '—' }}</span>
                  </div>
                </div>
              </div>
            </article>
          }
        </div>
      }

      @if (paginator?.total_records) {
        <div class="paginator-wrap">
          <app-paginator
            [currentPage]="1"
            [totalItems]="paginator.total_records"
            (pageChange)="pageChangeHandler($event)"
            (pageSizeChange)="pageSizeChangeHandler($event)">
          </app-paginator>
        </div>
      }
    </section>
  }

  @if (displayType === 'list') {
    <section class="results-card">
      <div class="table-wrapper">
        <p-table [value]="filteredUsers" styleClass="permissions-users-table">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'name' | translate }}</th>
              <th>{{ 'user_username' | translate }}</th>
              <th>{{ 'job_title' | translate }}</th>
              <th>{{ 'department' | translate }}</th>
              <th>{{ 'section' | translate }}</th>
              <th>{{ 'permission' | translate }}</th>
              <th>{{ 'options' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-user>
            <tr>
              <td>
                <div class="user-cell">
                  <span class="user-avatar sm">{{ getInitials(user.name || user.username) }}</span>
                  <strong>{{ user.name }}</strong>
                </div>
              </td>
              <td>{{ user.username }}</td>
              <td>{{ user.job_title || '—' }}</td>
              <td>{{ user.depData?.name || '—' }}</td>
              <td>{{ user.sectionData?.name || '—' }}</td>
              <td>
                <span class="role-badge">{{ dir === 'rtl' ? (user.roleData?.name_ar || user.role) : (user.roleData?.name_en || user.role) }}</span>
              </td>
              <td>
                <div class="table-actions-row">
                  <button type="button" class="table-action-icon" (click)="openUserModal(user.id)" pTooltip="{{ 'edit' | translate }}" tooltipPosition="top">
                    <i class="fa-solid fa-pen-to-square"></i>
                  </button>
                  <button type="button" class="table-action-icon" (click)="openPasswordModal(user.id)" pTooltip="{{ 'change_password' | translate }}" tooltipPosition="top">
                    <i class="fa-solid fa-key"></i>
                  </button>
                  <button type="button" class="table-action-icon danger" (click)="openDeleteUserModal(user.id)" pTooltip="{{ 'delete' | translate }}" tooltipPosition="top">
                    <i class="fa-solid fa-trash-can"></i>
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7">
                <div class="empty-state">
                  <div class="empty-state__icon"><i class="fa-solid fa-users-slash"></i></div>
                  <p class="empty-state__title">{{ dir === 'rtl' ? 'لا يوجد مستخدمون' : 'No users found' }}</p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      @if (paginator?.total_records) {
        <div class="paginator-wrap">
          <app-paginator
            [currentPage]="1"
            [totalItems]="paginator.total_records"
            (pageChange)="pageChangeHandler($event)"
            (pageSizeChange)="pageSizeChangeHandler($event)">
          </app-paginator>
        </div>
      }
    </section>
  }

@if (isModalVisible) {
  <div class="perm-modal-wrapper" role="presentation">
    <div class="perm-modal-overlay" (click)="closeUserModal()"></div>
    <div class="perm-modal" role="dialog" aria-modal="true" [attr.aria-label]="selectedUser.id ? (dir === 'rtl' ? 'تعديل مستخدم' : 'Edit user') : (dir === 'rtl' ? 'إضافة مستخدم' : 'Add user')">
      <header class="perm-modal__header">
        <div class="perm-modal__title-wrap">
          <span class="perm-modal__icon" [class.perm-modal__icon--edit]="!!selectedUser.id">
            <i class="fa-solid" [ngClass]="selectedUser.id ? 'fa-user-pen' : 'fa-user-plus'"></i>
          </span>
          <div class="perm-modal__titles">
            <h2 class="perm-modal__title">
              {{ selectedUser.id
                ? (dir === 'rtl' ? 'تعديل مستخدم' : 'Edit user')
                : (dir === 'rtl' ? 'إضافة مستخدم جديد' : 'Add new user') }}
            </h2>
            <p class="perm-modal__subtitle">
              {{ selectedUser.id
                ? (dir === 'rtl' ? 'حدّث بيانات المستخدم وصلاحياته.' : 'Update the user profile and permissions.')
                : (dir === 'rtl' ? 'أدخل بيانات المستخدم وعيّن الصلاحية المناسبة.' : 'Enter user details and assign the right role.') }}
            </p>
          </div>
        </div>
        <button type="button" class="perm-modal__close" (click)="closeUserModal()" [attr.aria-label]="dir === 'rtl' ? 'إغلاق' : 'Close'">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </header>

      <div class="perm-modal__body">
        <form class="perm-form" [formGroup]="userForm" (ngSubmit)="submit()">
          <section class="perm-form__section">
            <div class="perm-form__section-head">
              <i class="fa-solid fa-shield-halved"></i>
              <span>{{ dir === 'rtl' ? 'الصلاحية والتنظيم' : 'Role & organization' }}</span>
            </div>
            <div class="perm-form__grid">
              <div class="perm-form__field">
                <label class="perm-form__label" for="perm-role">{{ 'select_permission' | translate }}</label>
                <p-dropdown
                  inputId="perm-role"
                  (onChange)="roleChange()"
                  [(ngModel)]="selectedUser.role"
                  name="role"
                  [options]="roles"
                  optionValue="name_en"
                  [optionLabel]="dir === 'rtl' ? 'name_ar' : 'name_en'"
                  formControlName="role"
                  appendTo="body"
                  [baseZIndex]="1400"
                  panelStyleClass="perm-dropdown-panel"
                  styleClass="perm-form-dropdown"
                  [placeholder]="'select_permission' | translate" />
                @if (userForm.get('role')?.invalid && userForm.get('role')?.touched) {
                  <span class="perm-form__error">{{ 'field_is_required' | translate }}</span>
                }
              </div>

              <div class="perm-form__field">
                <label class="perm-form__label" for="perm-job">{{ 'job_title' | translate }}</label>
                <input
                  id="perm-job"
                  class="perm-form__input"
                  [(ngModel)]="selectedUser.job_title"
                  formControlName="job_title"
                  name="job_title"
                  pInputText
                  [placeholder]="dir === 'rtl' ? 'مثال: مدير إدارة' : 'e.g. Department Manager'" />
                @if (userForm.get('job_title')?.invalid && userForm.get('job_title')?.touched) {
                  <span class="perm-form__error">{{ 'field_is_required' | translate }}</span>
                }
              </div>

              <div class="perm-form__field">
                <label class="perm-form__label" for="perm-dept">{{ 'the_department' | translate }}</label>
                <p-dropdown
                  inputId="perm-dept"
                  [disabled]="isAdmin()"
                  (onChange)="depChange()"
                  formControlName="department_id"
                  [options]="departments"
                  [(ngModel)]="selectedUser.department_id"
                  optionValue="id"
                  optionLabel="name"
                  appendTo="body"
                  [baseZIndex]="1400"
                  panelStyleClass="perm-dropdown-panel"
                  styleClass="perm-form-dropdown"
                  [placeholder]="'select_the_department' | translate" />
                @if (userForm.get('department_id')?.invalid && userForm.get('department_id')?.touched) {
                  <span class="perm-form__error">{{ 'field_is_required' | translate }}</span>
                }
              </div>

              @if (showSectionDropdown) {
                <div class="perm-form__field">
                  <label class="perm-form__label" for="perm-section">{{ 'section' | translate }}</label>
                  <p-dropdown
                    inputId="perm-section"
                    [disabled]="isAdmin()"
                    [(ngModel)]="selectedUser.section_id"
                    name="section_id"
                    [options]="deps_Sections"
                    optionValue="id"
                    optionLabel="name"
                    formControlName="section_id"
                    appendTo="body"
                    [baseZIndex]="1400"
                    panelStyleClass="perm-dropdown-panel"
                    styleClass="perm-form-dropdown"
                    [placeholder]="'select_the_section' | translate" />
                  @if (userForm.get('section_id')?.invalid && userForm.get('section_id')?.touched) {
                    <span class="perm-form__error">{{ 'field_is_required' | translate }}</span>
                  }
                </div>
              }
            </div>
          </section>

          <section class="perm-form__section">
            <div class="perm-form__section-head">
              <i class="fa-solid fa-id-card"></i>
              <span>{{ dir === 'rtl' ? 'بيانات الحساب' : 'Account details' }}</span>
            </div>
            <div class="perm-form__grid">
              <div class="perm-form__field">
                <label class="perm-form__label" for="perm-name">{{ 'name' | translate }}</label>
                <input
                  id="perm-name"
                  class="perm-form__input"
                  [(ngModel)]="selectedUser.name"
                  formControlName="name"
                  pInputText
                  [placeholder]="dir === 'rtl' ? 'الاسم الكامل' : 'Full name'" />
                @if (userForm.get('name')?.invalid && userForm.get('name')?.touched) {
                  <span class="perm-form__error">{{ 'field_is_required' | translate }}</span>
                }
              </div>

              <div class="perm-form__field">
                <label class="perm-form__label" for="perm-username">{{ 'username' | translate }}</label>
                <input
                  id="perm-username"
                  class="perm-form__input"
                  [(ngModel)]="selectedUser.username"
                  formControlName="username"
                  pInputText
                  [placeholder]="dir === 'rtl' ? 'اسم المستخدم للدخول' : 'Login username'" />
                @if (userForm.get('username')?.invalid && userForm.get('username')?.touched) {
                  <span class="perm-form__error">{{ 'field_is_required' | translate }}</span>
                }
              </div>

              <div class="perm-form__field">
                <label class="perm-form__label" for="perm-email">{{ 'email' | translate }}</label>
                <input
                  id="perm-email"
                  class="perm-form__input"
                  [(ngModel)]="selectedUser.email"
                  type="email"
                  formControlName="email"
                  pInputText
                  [placeholder]="dir === 'rtl' ? 'name@example.com' : 'name@example.com'" />
                @if (userForm.get('email')?.errors?.['required'] && userForm.get('email')?.touched) {
                  <span class="perm-form__error">{{ 'field_is_required' | translate }}</span>
                }
                @if (userForm.get('email')?.errors?.['email'] && userForm.get('email')?.touched) {
                  <span class="perm-form__error">{{ 'Enter a valid email format' | translate }}</span>
                }
              </div>

              @if (!selectedUser.id) {
                <div class="perm-form__field">
                  <label class="perm-form__label" for="perm-password">{{ 'password' | translate }}</label>
                  <div class="perm-form__password">
                    <input
                      id="perm-password"
                      class="perm-form__input"
                      [type]="passwordFieldType"
                      [(ngModel)]="selectedUser.password"
                      name="password"
                      formControlName="password"
                      pInputText
                      [placeholder]="dir === 'rtl' ? '6 أحرف على الأقل' : 'At least 6 characters'" />
                    <button
                      type="button"
                      class="perm-form__eye"
                      (click)="togglePasswordVisibility($event)"
                      [attr.aria-label]="dir === 'rtl' ? 'إظهار/إخفاء كلمة المرور' : 'Toggle password visibility'">
                      <i [ngClass]="passwordIconClass"></i>
                    </button>
                  </div>
                  @if (userForm.get('password')?.invalid && userForm.get('password')?.touched) {
                    <span class="perm-form__error">{{ 'field_is_required' | translate }}</span>
                  }
                </div>
              }
            </div>
          </section>

          <div class="perm-form__actions">
            <button type="button" class="perm-btn perm-btn--ghost" (click)="closeUserModal()">
              {{ 'cancel' | translate }}
            </button>
            <button type="submit" class="perm-btn perm-btn--primary">
              <i class="fa-solid" [ngClass]="selectedUser.id ? 'fa-floppy-disk' : 'fa-user-plus'"></i>
              <span>{{ 'save' | translate }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
}

@if (isPasswordModalVisible) {
  <div class="perm-modal-wrapper" role="presentation">
    <div class="perm-modal-overlay" (click)="closePasswordModal()"></div>
    <div class="perm-modal perm-modal--sm" role="dialog" aria-modal="true">
      <header class="perm-modal__header">
        <div class="perm-modal__title-wrap">
          <span class="perm-modal__icon perm-modal__icon--key">
            <i class="fa-solid fa-key"></i>
          </span>
          <div class="perm-modal__titles">
            <h2 class="perm-modal__title">{{ 'change_password' | translate }}</h2>
            <p class="perm-modal__subtitle">
              {{ dir === 'rtl' ? 'أدخل كلمة مرور جديدة للمستخدم.' : 'Enter a new password for this user.' }}
            </p>
          </div>
        </div>
        <button type="button" class="perm-modal__close" (click)="closePasswordModal()" [attr.aria-label]="dir === 'rtl' ? 'إغلاق' : 'Close'">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </header>

      <div class="perm-modal__body">
        <form class="perm-form" [formGroup]="passwordForm" (ngSubmit)="submitPassword()">
          <div class="perm-form__field">
            <label class="perm-form__label" for="perm-new-password">{{ 'password' | translate }}</label>
            <div class="perm-form__password">
              <input
                id="perm-new-password"
                class="perm-form__input"
                [type]="passwordFieldType"
                formControlName="password"
                pInputText
                [placeholder]="dir === 'rtl' ? 'كلمة المرور الجديدة' : 'New password'" />
              <button
                type="button"
                class="perm-form__eye"
                (click)="togglePasswordVisibility($event)"
                [attr.aria-label]="dir === 'rtl' ? 'إظهار/إخفاء كلمة المرور' : 'Toggle password visibility'">
                <i [ngClass]="passwordIconClass"></i>
              </button>
            </div>
            @if ((password_control.invalid && !password_control.pristine) || (isModalSubmitted && password_control.invalid)) {
              <span class="perm-form__error">{{ 'field_is_required' | translate }}</span>
            }
          </div>

          <div class="perm-form__actions">
            <button type="button" class="perm-btn perm-btn--ghost" (click)="closePasswordModal()">
              {{ 'cancel' | translate }}
            </button>
            <button type="submit" class="perm-btn perm-btn--primary">
              <i class="fa-solid fa-floppy-disk"></i>
              <span>{{ 'save' | translate }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
}


    @if(isDeleteUserModal){
    <div>
        <div class="g-modal">
            <div class="flex  justify-content-between align-items-center flex-row-reverse ">
                <div (click)="closeDeleteUserModal()"
                    class="  bg-red-500 g-c-white  cursor-pointer  w-3rem p-1 shadow-4 text-center  font-bold text-xl  bg-secondary-color border-round">
                    <i class="fa-solid fa-xmark"></i>

                </div>
                <div class="titel font-bold g-c-primaryDarkerColor g-c-primaryDarkerColor">

                </div>
            </div>
            <div class="br">

            </div>
            <div class="modal__body">
                <div class="mx-auto mb-5">
                    <div class="flex justify-content-between">

                        <div class="font-bold text-lg g-c-primaryDarkColor">
                            <i class="fa-solid fa-list-ul"></i>
                            {{"employee_deletion_procedures"|translate}}
                            <ul>
                                <li class="font-bold g-c-primaryDarkColor">
                                    <div class="flex align-items-center gap-2">

                                        @if(UserIndicators.length){
                                        <i class="pi pi-times-circle text-red-500"></i>
                                        }@else{
                                        <i class="pi pi-check-square text-green-500"></i>
                                        }
                                        @if(UserIndicators.length){

                                        <div>
                                            {{'transfer_indicators'|translate}} : {{UserProjects.length}}
                                            {{'indicator'|translate}}
                                        </div>
                                        }@else{
                                        {{'transfer_indicators'|translate}} : {{'no_indicators'|translate}}
                                        }

                                    </div>


                                    <ul class="font-light mt-2 p-1">
                                        <li class="g-c-black p-1">
                                            {{"assign_another_officer_for_each_indicator"|translate}}
                                        </li>
                                    </ul>
                                </li>
                                <li class="font-bold g-c-primaryDarkColor">
                                    <div class="flex align-items-center gap-2">

                                        @if( UserProjects.length){
                                        <i class="pi pi-times-circle text-red-500"></i>
                                        }@else{
                                        <i class="pi pi-check-square text-green-500"></i>
                                        }
                                        @if(UserProjects.length){

                                        <div>

                                            {{'transfer_initiatives'|translate}} : {{UserProjects.length}}
                                        </div>
                                        }@else{
                                        {{'transfer_initiatives'|translate}} : {{'no_initiatives'|translate}}
                                        }

                                    </div>





                                    <ul class="font-light mt-2 p-1">
                                        <li class="g-c-black p-1"></li>
                                        <li class="g-c-black p-1">
                                            {{"assign_another_officer_for_each_indicator"|translate}}</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>

                        @if(UserIndicators.length){
                        <!-- #done -->
                        <div>
                            <svg width="297" height="143" viewBox="0 0 297 143" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect width="297" height="143" rx="8" fill="white" />
                                <path
                                    d="M147.959 16.4321C147.125 16.4332 146.309 16.1868 145.615 15.7239C144.92 15.2611 144.379 14.6027 144.059 13.8321C143.74 13.0615 143.656 12.2133 143.818 11.3949C143.981 10.5766 144.382 9.82481 144.972 9.23484C145.562 8.64487 146.314 8.24323 147.132 8.08073C147.951 7.91824 148.799 8.00222 149.569 8.32203C150.34 8.64184 150.998 9.1831 151.461 9.8773C151.924 10.5715 152.171 11.3874 152.169 12.2218C152.169 13.3384 151.726 14.4093 150.936 15.1989C150.147 15.9885 149.076 16.4321 147.959 16.4321Z"
                                    fill="#949494" />
                                <path
                                    d="M130.968 18.0186C130.134 18.0197 129.318 17.7733 128.624 17.3104C127.929 16.8476 127.388 16.1892 127.068 15.4186C126.748 14.648 126.664 13.7998 126.827 12.9814C126.989 12.1631 127.391 11.4113 127.981 10.8213C128.571 10.2314 129.323 9.82971 130.141 9.66722C130.96 9.50472 131.808 9.5887 132.578 9.90852C133.349 10.2283 134.007 10.7696 134.47 11.4638C134.933 12.158 135.179 12.9739 135.178 13.8083C135.178 14.9249 134.735 15.9958 133.945 16.7854C133.156 17.575 132.085 18.0186 130.968 18.0186Z"
                                    fill="#949494" />
                                <path
                                    d="M114.523 22.5381C116.851 22.5381 118.739 20.6505 118.739 18.322C118.739 15.9936 116.851 14.106 114.523 14.106C112.194 14.106 110.307 15.9936 110.307 18.322C110.307 20.6505 112.194 22.5381 114.523 22.5381Z"
                                    fill="#949494" />
                                <path
                                    d="M99.1132 29.8478C98.2789 29.8489 97.4629 29.6025 96.7687 29.1397C96.0745 28.6768 95.5333 28.0184 95.2134 27.2478C94.8936 26.4772 94.8097 25.629 94.9722 24.8107C95.1346 23.9923 95.5363 23.2405 96.1263 22.6506C96.7162 22.0606 97.468 21.6589 98.2864 21.4964C99.1047 21.3339 99.9529 21.4179 100.724 21.7377C101.494 22.0576 102.153 22.5988 102.615 23.293C103.078 23.9872 103.325 24.8031 103.323 25.6375C103.323 26.1904 103.215 26.7379 103.003 27.2487C102.791 27.7595 102.481 28.2237 102.09 28.6146C101.699 29.0056 101.235 29.3157 100.724 29.5273C100.214 29.7389 99.6661 29.8478 99.1132 29.8478Z"
                                    fill="#949494" />
                                <path
                                    d="M85.2049 39.7C87.5333 39.7 89.4209 37.8125 89.4209 35.484C89.4209 33.1555 87.5333 31.2679 85.2049 31.2679C82.8764 31.2679 80.9888 33.1555 80.9888 35.484C80.9888 37.8125 82.8764 39.7 85.2049 39.7Z"
                                    fill="#949494" />
                                <path
                                    d="M73.216 51.8274C72.3822 51.8274 71.5671 51.5802 70.8737 51.1169C70.1804 50.6536 69.64 49.9952 69.3209 49.2248C69.0018 48.4544 68.9183 47.6067 69.081 46.7889C69.2437 45.971 69.6452 45.2198 70.2349 44.6302C70.8245 44.0406 71.5757 43.639 72.3935 43.4763C73.2114 43.3137 74.0591 43.3972 74.8295 43.7163C75.5998 44.0354 76.2583 44.5757 76.7216 45.2691C77.1848 45.9624 77.4321 46.7775 77.4321 47.6114C77.4329 48.1653 77.3243 48.7138 77.1127 49.2257C76.9011 49.7375 76.5906 50.2026 76.1989 50.5943C75.8073 50.9859 75.3422 51.2964 74.8304 51.508C74.3185 51.7196 73.7699 51.8282 73.216 51.8274Z"
                                    fill="#949494" />
                                <path
                                    d="M223.097 50.9335C225.425 50.9335 227.313 49.0459 227.313 46.7174C227.313 44.389 225.425 42.5014 223.097 42.5014C220.768 42.5014 218.881 44.389 218.881 46.7174C218.881 49.0459 220.768 50.9335 223.097 50.9335Z"
                                    fill="#949494" />
                                <path
                                    d="M210.965 38.9499C213.293 38.9499 215.181 37.0623 215.181 34.7339C215.181 32.4054 213.293 30.5178 210.965 30.5178C208.636 30.5178 206.749 32.4054 206.749 34.7339C206.749 37.0623 208.636 38.9499 210.965 38.9499Z"
                                    fill="#949494" />
                                <path
                                    d="M196.935 29.275C196.102 29.275 195.286 29.0277 194.593 28.5645C193.9 28.1012 193.359 27.4427 193.04 26.6724C192.721 25.902 192.638 25.0543 192.8 24.2364C192.963 23.4186 193.365 22.6674 193.954 22.0778C194.544 21.4881 195.295 21.0866 196.113 20.9239C196.931 20.7612 197.778 20.8447 198.549 21.1638C199.319 21.4829 199.978 22.0233 200.441 22.7166C200.904 23.41 201.151 24.2251 201.151 25.059C201.151 26.1771 200.707 27.2495 199.917 28.0401C199.126 28.8308 198.054 29.275 196.935 29.275Z"
                                    fill="#949494" />
                                <path
                                    d="M181.441 22.1375C183.77 22.1375 185.657 20.2499 185.657 17.9214C185.657 15.593 183.77 13.7054 181.441 13.7054C179.113 13.7054 177.225 15.593 177.225 17.9214C177.225 20.2499 179.113 22.1375 181.441 22.1375Z"
                                    fill="#949494" />
                                <path
                                    d="M164.943 17.8183C164.109 17.8195 163.293 17.5732 162.599 17.1106C161.905 16.648 161.364 15.99 161.044 15.2197C160.724 14.4494 160.64 13.6015 160.802 12.7833C160.964 11.9651 161.365 11.2133 161.954 10.6231C162.544 10.0329 163.295 9.6308 164.113 9.46766C164.931 9.30452 165.779 9.38768 166.549 9.70662C167.32 10.0255 167.979 10.5659 168.442 11.2594C168.906 11.9528 169.153 12.7682 169.153 13.6023C169.153 14.7195 168.71 15.7909 167.921 16.5814C167.131 17.3719 166.06 17.8168 164.943 17.8183Z"
                                    fill="#949494" />
                                <g clip-path="url(#clip0_445_10244)">
                                    <path
                                        d="M112.07 85.95H107.642C107.273 85.95 106.975 85.65 106.975 85.2834V72.7884C106.975 72.42 107.273 72.1217 107.642 72.1217H112.07C112.438 72.1217 112.737 72.4217 112.737 72.7884V85.2834C112.737 85.65 112.438 85.95 112.07 85.95Z"
                                        fill="#5E9CEA" />
                                    <path
                                        d="M128.658 85.95H124.23C123.862 85.95 123.563 85.65 123.563 85.2833V64.515C123.563 64.1467 123.862 63.8483 124.23 63.8483H128.658C129.027 63.8483 129.325 64.1483 129.325 64.515V85.2817C129.325 85.65 129.025 85.95 128.658 85.95Z"
                                        fill="#FECD57" />
                                    <path
                                        d="M136.952 85.9501H132.523C132.155 85.9501 131.857 85.6501 131.857 85.2834V59.2001C131.857 58.8317 132.155 58.5334 132.523 58.5334H136.952C137.32 58.5334 137.618 58.8334 137.618 59.2001V85.2817C137.618 85.6501 137.32 85.9501 136.952 85.9501Z"
                                        fill="#FB6D51" />
                                    <path
                                        d="M120.365 85.95H115.935C115.567 85.95 115.268 85.65 115.268 85.2833V69.27C115.268 68.9017 115.567 68.6033 115.935 68.6033H120.365C120.733 68.6033 121.032 68.9033 121.032 69.27V85.2833C121.032 85.65 120.732 85.95 120.365 85.95Z"
                                        fill="#9ED36A" />
                                    <path
                                        d="M140.337 85.95H103.608C103.24 85.95 102.942 85.65 102.942 85.2834V48.7734C102.942 48.405 103.24 48.1067 103.608 48.1067C103.977 48.1067 104.275 48.4067 104.275 48.7734V84.615H140.335C140.703 84.615 141.002 84.915 141.002 85.2817C141.002 85.6484 140.703 85.95 140.337 85.95Z"
                                        fill="#363636" />
                                    <path
                                        d="M103.608 52.4984H101.663C101.295 52.4984 100.997 52.1984 100.997 51.8317C100.997 51.465 101.295 51.165 101.663 51.165H103.608C103.977 51.165 104.275 51.465 104.275 51.8317C104.275 52.1984 103.977 52.4984 103.608 52.4984Z"
                                        fill="#363636" />
                                    <path
                                        d="M103.608 57.34H101.663C101.295 57.34 100.997 57.04 100.997 56.6734C100.997 56.3067 101.295 56.0067 101.663 56.0067H103.608C103.977 56.0067 104.275 56.3067 104.275 56.6734C104.275 57.04 103.977 57.34 103.608 57.34Z"
                                        fill="#363636" />
                                    <path
                                        d="M103.608 62.185H101.663C101.295 62.185 100.997 61.885 100.997 61.5184C100.997 61.1517 101.295 60.8517 101.663 60.8517H103.608C103.977 60.8517 104.275 61.1517 104.275 61.5184C104.275 61.885 103.977 62.185 103.608 62.185Z"
                                        fill="#363636" />
                                    <path
                                        d="M103.608 67.0267H101.663C101.295 67.0267 100.997 66.7267 100.997 66.36C100.997 65.9934 101.295 65.6934 101.663 65.6934H103.608C103.977 65.6934 104.275 65.9934 104.275 66.36C104.275 66.7267 103.977 67.0267 103.608 67.0267Z"
                                        fill="#363636" />
                                    <path
                                        d="M103.608 71.87H101.663C101.295 71.87 100.997 71.57 100.997 71.2033C100.997 70.8367 101.295 70.5367 101.663 70.5367H103.608C103.977 70.5367 104.275 70.8367 104.275 71.2033C104.275 71.57 103.977 71.87 103.608 71.87Z"
                                        fill="#363636" />
                                    <path
                                        d="M103.608 76.7134H101.663C101.295 76.7134 100.997 76.4134 100.997 76.0467C100.997 75.6801 101.295 75.3801 101.663 75.3801H103.608C103.977 75.3801 104.275 75.6801 104.275 76.0467C104.275 76.4134 103.977 76.7134 103.608 76.7134Z"
                                        fill="#363636" />
                                    <path
                                        d="M103.608 81.5567H101.663C101.295 81.5567 100.997 81.2567 100.997 80.8901C100.997 80.5234 101.295 80.2234 101.663 80.2234H103.608C103.977 80.2234 104.275 80.5234 104.275 80.8901C104.275 81.2567 103.977 81.5567 103.608 81.5567Z"
                                        fill="#363636" />
                                    <path
                                        d="M136.825 87.895C136.457 87.895 136.158 87.595 136.158 87.2284V85.2834C136.158 84.915 136.457 84.6167 136.825 84.6167C137.193 84.6167 137.492 84.9167 137.492 85.2834V87.2284C137.492 87.595 137.193 87.895 136.825 87.895Z"
                                        fill="#363636" />
                                    <path
                                        d="M131.982 87.895C131.613 87.895 131.315 87.595 131.315 87.2284V85.2834C131.315 84.915 131.613 84.6167 131.982 84.6167C132.35 84.6167 132.648 84.9167 132.648 85.2834V87.2284C132.648 87.595 132.35 87.895 131.982 87.895Z"
                                        fill="#363636" />
                                    <path
                                        d="M127.14 87.895C126.772 87.895 126.473 87.595 126.473 87.2284V85.2834C126.473 84.915 126.772 84.6167 127.14 84.6167C127.508 84.6167 127.807 84.9167 127.807 85.2834V87.2284C127.805 87.595 127.507 87.895 127.14 87.895Z"
                                        fill="#363636" />
                                    <path
                                        d="M122.297 87.895C121.928 87.895 121.63 87.595 121.63 87.2284V85.2834C121.63 84.915 121.928 84.6167 122.297 84.6167C122.665 84.6167 122.963 84.9167 122.963 85.2834V87.2284C122.963 87.595 122.665 87.895 122.297 87.895Z"
                                        fill="#363636" />
                                    <path
                                        d="M117.453 87.895C117.085 87.895 116.787 87.595 116.787 87.2284V85.2834C116.787 84.915 117.085 84.6167 117.453 84.6167C117.822 84.6167 118.12 84.9167 118.12 85.2834V87.2284C118.12 87.595 117.822 87.895 117.453 87.895Z"
                                        fill="#363636" />
                                    <path
                                        d="M112.61 87.895C112.242 87.895 111.943 87.595 111.943 87.2284V85.2834C111.943 84.915 112.242 84.6167 112.61 84.6167C112.978 84.6167 113.277 84.9167 113.277 85.2834V87.2284C113.277 87.595 112.978 87.895 112.61 87.895Z"
                                        fill="#363636" />
                                    <path
                                        d="M107.768 87.895C107.4 87.895 107.102 87.595 107.102 87.2284V85.2834C107.102 84.915 107.4 84.6167 107.768 84.6167C108.137 84.6167 108.435 84.9167 108.435 85.2834V87.2284C108.433 87.595 108.135 87.895 107.768 87.895Z"
                                        fill="#363636" />
                                    <path
                                        d="M106.24 69.145C105.978 69.145 105.732 68.99 105.625 68.7333C105.483 68.3933 105.645 68.0033 105.983 67.8633L107.915 67.08C108.958 66.6633 110.002 66.2483 111.038 65.8183C111.167 65.765 111.305 65.6617 111.395 65.5517C112.18 64.595 112.945 63.625 113.702 62.6483C113.975 62.2983 114.312 62.1267 114.763 62.1083C115.972 62.06 118.377 61.94 119.582 61.8583C119.627 61.8567 119.713 61.8217 119.743 61.795C120.273 61.275 120.827 60.7467 121.38 60.22C121.857 59.7667 122.332 59.3133 122.792 58.865C123.057 58.6083 123.478 58.4217 123.867 58.395C125.023 58.3117 126.465 58.2433 127.625 58.2C127.723 58.195 127.728 58.1883 127.778 58.1267C128.252 57.5433 128.683 56.965 129.117 56.385C129.547 55.8083 129.977 55.2333 130.448 54.65C130.757 54.27 131.127 54.085 131.613 54.0667C132.788 54.025 133.963 53.965 135.135 53.8833C135.195 53.8767 135.3 53.8317 135.333 53.8C136.083 53.07 136.822 52.3233 137.565 51.5733L138.292 50.8417C138.552 50.5817 138.973 50.5783 139.235 50.84C139.495 51.0983 139.497 51.52 139.237 51.7817L138.512 52.5117C137.763 53.2683 137.018 54.0183 136.262 54.7583C136.002 55.0083 135.597 55.1867 135.223 55.2117C134.037 55.295 132.847 55.3533 131.657 55.395C131.555 55.4 131.55 55.4033 131.483 55.4867C131.023 56.055 130.603 56.6183 130.183 57.18C129.74 57.7733 129.297 58.3683 128.81 58.9667C128.51 59.3333 128.15 59.51 127.675 59.5283C126.528 59.5717 125.105 59.64 123.96 59.7233C123.877 59.7283 123.755 59.785 123.72 59.8183C123.258 60.27 122.78 60.725 122.298 61.1817C121.75 61.705 121.2 62.23 120.673 62.745C120.425 62.9883 120.03 63.1617 119.668 63.1867C118.457 63.27 116.033 63.3883 114.818 63.4367C113.99 64.45 113.217 65.43 112.425 66.3967C112.195 66.6767 111.873 66.9167 111.545 67.05C110.505 67.4817 109.457 67.9 108.407 68.3183L106.495 69.0933C106.412 69.1283 106.325 69.145 106.24 69.145Z"
                                        fill="#E5E8EC" />
                                </g>
                                <g clip-path="url(#clip1_445_10244)">
                                    <path
                                        d="M168.07 85.95H163.642C163.273 85.95 162.975 85.65 162.975 85.2834V72.7884C162.975 72.42 163.273 72.1217 163.642 72.1217H168.07C168.438 72.1217 168.737 72.4217 168.737 72.7884V85.2834C168.737 85.65 168.438 85.95 168.07 85.95Z"
                                        fill="#5E9CEA" />
                                    <path
                                        d="M184.658 85.95H180.23C179.862 85.95 179.563 85.65 179.563 85.2833V64.515C179.563 64.1467 179.862 63.8483 180.23 63.8483H184.658C185.027 63.8483 185.325 64.1483 185.325 64.515V85.2817C185.325 85.65 185.025 85.95 184.658 85.95Z"
                                        fill="#FECD57" />
                                    <path
                                        d="M192.952 85.9501H188.523C188.155 85.9501 187.857 85.6501 187.857 85.2834V59.2001C187.857 58.8317 188.155 58.5334 188.523 58.5334H192.952C193.32 58.5334 193.618 58.8334 193.618 59.2001V85.2817C193.618 85.6501 193.32 85.9501 192.952 85.9501Z"
                                        fill="#FB6D51" />
                                    <path
                                        d="M176.365 85.95H171.935C171.567 85.95 171.268 85.65 171.268 85.2833V69.27C171.268 68.9017 171.567 68.6033 171.935 68.6033H176.365C176.733 68.6033 177.032 68.9033 177.032 69.27V85.2833C177.032 85.65 176.732 85.95 176.365 85.95Z"
                                        fill="#9ED36A" />
                                    <path
                                        d="M196.337 85.95H159.608C159.24 85.95 158.942 85.65 158.942 85.2834V48.7734C158.942 48.405 159.24 48.1067 159.608 48.1067C159.977 48.1067 160.275 48.4067 160.275 48.7734V84.615H196.335C196.703 84.615 197.002 84.915 197.002 85.2817C197.002 85.6484 196.703 85.95 196.337 85.95Z"
                                        fill="#363636" />
                                    <path
                                        d="M159.608 52.4984H157.663C157.295 52.4984 156.997 52.1984 156.997 51.8317C156.997 51.465 157.295 51.165 157.663 51.165H159.608C159.977 51.165 160.275 51.465 160.275 51.8317C160.275 52.1984 159.977 52.4984 159.608 52.4984Z"
                                        fill="#363636" />
                                    <path
                                        d="M159.608 57.34H157.663C157.295 57.34 156.997 57.04 156.997 56.6734C156.997 56.3067 157.295 56.0067 157.663 56.0067H159.608C159.977 56.0067 160.275 56.3067 160.275 56.6734C160.275 57.04 159.977 57.34 159.608 57.34Z"
                                        fill="#363636" />
                                    <path
                                        d="M159.608 62.185H157.663C157.295 62.185 156.997 61.885 156.997 61.5184C156.997 61.1517 157.295 60.8517 157.663 60.8517H159.608C159.977 60.8517 160.275 61.1517 160.275 61.5184C160.275 61.885 159.977 62.185 159.608 62.185Z"
                                        fill="#363636" />
                                    <path
                                        d="M159.608 67.0267H157.663C157.295 67.0267 156.997 66.7267 156.997 66.36C156.997 65.9934 157.295 65.6934 157.663 65.6934H159.608C159.977 65.6934 160.275 65.9934 160.275 66.36C160.275 66.7267 159.977 67.0267 159.608 67.0267Z"
                                        fill="#363636" />
                                    <path
                                        d="M159.608 71.87H157.663C157.295 71.87 156.997 71.57 156.997 71.2033C156.997 70.8367 157.295 70.5367 157.663 70.5367H159.608C159.977 70.5367 160.275 70.8367 160.275 71.2033C160.275 71.57 159.977 71.87 159.608 71.87Z"
                                        fill="#363636" />
                                    <path
                                        d="M159.608 76.7134H157.663C157.295 76.7134 156.997 76.4134 156.997 76.0467C156.997 75.6801 157.295 75.3801 157.663 75.3801H159.608C159.977 75.3801 160.275 75.6801 160.275 76.0467C160.275 76.4134 159.977 76.7134 159.608 76.7134Z"
                                        fill="#363636" />
                                    <path
                                        d="M159.608 81.5567H157.663C157.295 81.5567 156.997 81.2567 156.997 80.8901C156.997 80.5234 157.295 80.2234 157.663 80.2234H159.608C159.977 80.2234 160.275 80.5234 160.275 80.8901C160.275 81.2567 159.977 81.5567 159.608 81.5567Z"
                                        fill="#363636" />
                                    <path
                                        d="M192.825 87.895C192.457 87.895 192.158 87.595 192.158 87.2284V85.2834C192.158 84.915 192.457 84.6167 192.825 84.6167C193.193 84.6167 193.492 84.9167 193.492 85.2834V87.2284C193.492 87.595 193.193 87.895 192.825 87.895Z"
                                        fill="#363636" />
                                    <path
                                        d="M187.982 87.895C187.613 87.895 187.315 87.595 187.315 87.2284V85.2834C187.315 84.915 187.613 84.6167 187.982 84.6167C188.35 84.6167 188.648 84.9167 188.648 85.2834V87.2284C188.648 87.595 188.35 87.895 187.982 87.895Z"
                                        fill="#363636" />
                                    <path
                                        d="M183.14 87.895C182.772 87.895 182.473 87.595 182.473 87.2284V85.2834C182.473 84.915 182.772 84.6167 183.14 84.6167C183.508 84.6167 183.807 84.9167 183.807 85.2834V87.2284C183.805 87.595 183.507 87.895 183.14 87.895Z"
                                        fill="#363636" />
                                    <path
                                        d="M178.297 87.895C177.928 87.895 177.63 87.595 177.63 87.2284V85.2834C177.63 84.915 177.928 84.6167 178.297 84.6167C178.665 84.6167 178.963 84.9167 178.963 85.2834V87.2284C178.963 87.595 178.665 87.895 178.297 87.895Z"
                                        fill="#363636" />
                                    <path
                                        d="M173.453 87.895C173.085 87.895 172.787 87.595 172.787 87.2284V85.2834C172.787 84.915 173.085 84.6167 173.453 84.6167C173.822 84.6167 174.12 84.9167 174.12 85.2834V87.2284C174.12 87.595 173.822 87.895 173.453 87.895Z"
                                        fill="#363636" />
                                    <path
                                        d="M168.61 87.895C168.242 87.895 167.943 87.595 167.943 87.2284V85.2834C167.943 84.915 168.242 84.6167 168.61 84.6167C168.978 84.6167 169.277 84.9167 169.277 85.2834V87.2284C169.277 87.595 168.978 87.895 168.61 87.895Z"
                                        fill="#363636" />
                                    <path
                                        d="M163.768 87.895C163.4 87.895 163.102 87.595 163.102 87.2284V85.2834C163.102 84.915 163.4 84.6167 163.768 84.6167C164.137 84.6167 164.435 84.9167 164.435 85.2834V87.2284C164.433 87.595 164.135 87.895 163.768 87.895Z"
                                        fill="#363636" />
                                    <path
                                        d="M162.24 69.145C161.978 69.145 161.732 68.99 161.625 68.7333C161.483 68.3933 161.645 68.0033 161.983 67.8633L163.915 67.08C164.958 66.6633 166.002 66.2483 167.038 65.8183C167.167 65.765 167.305 65.6617 167.395 65.5517C168.18 64.595 168.945 63.625 169.702 62.6483C169.975 62.2983 170.312 62.1267 170.763 62.1083C171.972 62.06 174.377 61.94 175.582 61.8583C175.627 61.8567 175.713 61.8217 175.743 61.795C176.273 61.275 176.827 60.7467 177.38 60.22C177.857 59.7667 178.332 59.3133 178.792 58.865C179.057 58.6083 179.478 58.4217 179.867 58.395C181.023 58.3117 182.465 58.2433 183.625 58.2C183.723 58.195 183.728 58.1883 183.778 58.1267C184.252 57.5433 184.683 56.965 185.117 56.385C185.547 55.8083 185.977 55.2333 186.448 54.65C186.757 54.27 187.127 54.085 187.613 54.0667C188.788 54.025 189.963 53.965 191.135 53.8833C191.195 53.8767 191.3 53.8317 191.333 53.8C192.083 53.07 192.822 52.3233 193.565 51.5733L194.292 50.8417C194.552 50.5817 194.973 50.5783 195.235 50.84C195.495 51.0983 195.497 51.52 195.237 51.7817L194.512 52.5117C193.763 53.2683 193.018 54.0183 192.262 54.7583C192.002 55.0083 191.597 55.1867 191.223 55.2117C190.037 55.295 188.847 55.3533 187.657 55.395C187.555 55.4 187.55 55.4033 187.483 55.4867C187.023 56.055 186.603 56.6183 186.183 57.18C185.74 57.7733 185.297 58.3683 184.81 58.9667C184.51 59.3333 184.15 59.51 183.675 59.5283C182.528 59.5717 181.105 59.64 179.96 59.7233C179.877 59.7283 179.755 59.785 179.72 59.8183C179.258 60.27 178.78 60.725 178.298 61.1817C177.75 61.705 177.2 62.23 176.673 62.745C176.425 62.9883 176.03 63.1617 175.668 63.1867C174.457 63.27 172.033 63.3883 170.818 63.4367C169.99 64.45 169.217 65.43 168.425 66.3967C168.195 66.6767 167.873 66.9167 167.545 67.05C166.505 67.4817 165.457 67.9 164.407 68.3183L162.495 69.0933C162.412 69.1283 162.325 69.145 162.24 69.145Z"
                                        fill="#E5E8EC" />
                                </g>
                                <g clip-path="url(#clip2_445_10244)">
                                    <path
                                        d="M219.333 111.667C221.168 111.653 222.653 110.168 222.667 108.333H226C231.523 108.333 236 112.811 236 118.333V133.333H202.667V118.333C202.667 112.811 207.144 108.333 212.667 108.333H216C216.005 110.172 217.495 111.661 219.333 111.667Z"
                                        fill="#C8C8C8" />
                                    <path
                                        d="M222.667 108.333C222.653 110.168 221.168 111.653 219.333 111.667C217.495 111.661 216.005 110.172 216 108.333V104.316C218.129 105.228 220.538 105.228 222.667 104.316V108.333Z"
                                        fill="white" />
                                    <path
                                        d="M227.667 93.3331V96.6669C227.659 99.9811 225.699 102.98 222.667 104.316C220.538 105.228 218.129 105.228 216 104.316L213.433 102.567C211.875 100.999 211 98.8776 211 96.6669V93.3331C212.335 93.3618 213.623 92.8442 214.567 91.9C215.511 90.9564 216.029 89.668 216 88.3331C216 88.3331 216 93.3331 227.667 93.3331Z"
                                        fill="white" />
                                    <path
                                        d="M227.667 88.3331V93.3331C216 93.3331 216 88.3331 216 88.3331C216.029 89.668 215.511 90.9564 214.567 91.9C213.623 92.8442 212.335 93.3618 211 93.3331V88.3331C211 83.7311 214.731 80 219.333 80C223.936 80 227.667 83.7311 227.667 88.3331Z"
                                        fill="#C8C8C8" />
                                    <path
                                        d="M271 125H236V118.333C236 112.811 231.523 108.333 226 108.333H222.667V104.316C225.699 102.98 227.659 99.9811 227.667 96.6669V88.3331H244.333V91.6669C244.339 93.5052 245.828 94.9945 247.667 95H251C252.838 94.9945 254.328 93.5052 254.333 91.6669V88.3331H274.333V121.667C274.328 123.505 272.838 124.995 271 125Z"
                                        fill="white" />
                                    <path
                                        d="M254.333 88.3331V91.6669C254.328 93.5052 252.838 94.9945 251 95H247.667C245.828 94.9945 244.339 93.5052 244.333 91.6669V85C244.339 83.1616 245.828 81.6724 247.667 81.6669H251C252.838 81.6724 254.328 83.1616 254.333 85V88.3331Z"
                                        fill="#C8C8C8" />
                                    <path
                                        d="M279.333 71.6669V85C279.328 86.8384 277.838 88.3276 276 88.3331H254.333V85C254.328 83.1616 252.838 81.6724 251 82.1669H247.667C245.828 82.1724 244.339 83.6616 244.333 85V88.3331H227.667C227.667 83.7311 223.936 80 219.333 80V71.6669C219.339 69.8279 220.828 68.3386 222.667 68.3331H276C277.838 68.3386 279.328 69.8279 279.333 71.6669Z"
                                        fill="white" />
                                    <path
                                        d="M226 106.667H224.333V105.312C227.418 103.524 229.322 100.232 229.333 96.6669V88.3331C229.333 82.8107 224.856 78.3331 219.333 78.3331C213.811 78.3331 209.333 82.8107 209.333 88.3331V96.6669C209.329 99.317 210.378 101.86 212.248 103.738C212.323 103.814 212.406 103.883 212.494 103.943L214.326 105.197V106.667H212.667C206.226 106.674 201.007 111.893 201 118.333V133.333C201 134.254 201.746 135 202.667 135H236C236.92 135 237.667 134.254 237.667 133.333V118.333C237.66 111.893 232.44 106.674 226 106.667ZM220.49 109.521C220.185 109.831 219.768 110.003 219.333 110C218.413 110 217.667 109.254 217.667 108.333V106.517C218.769 106.717 219.898 106.717 221 106.517V108.333C221.001 108.783 220.816 109.213 220.49 109.521ZM219.333 81.6669C223.015 81.6669 226 84.6515 226 88.3331V91.6302C218.132 91.2653 217.667 88.3331 217.667 88.3331C217.667 87.4127 216.92 86.6669 216 86.6669C215.08 86.6669 214.333 87.4127 214.333 88.3331C214.451 89.5673 213.785 90.7428 212.667 91.2769V88.3331C212.667 84.6515 215.651 81.6669 219.333 81.6669ZM212.667 94.79C214.215 94.4354 215.584 93.5339 216.522 92.2516C218.158 93.5651 221.021 94.7516 226 94.9652V96.6669C225.993 99.3134 224.432 101.709 222.013 102.783C220.351 103.492 218.475 103.513 216.797 102.842L214.512 101.285C213.326 100.04 212.666 98.3862 212.667 96.6669V94.79ZM234.333 131.667H204.333V118.333C204.339 113.734 208.067 110.005 212.667 110H214.64C215.144 111.412 216.255 112.523 217.667 113.027V126.667H221V113.032C221.696 112.795 222.329 112.399 222.847 111.877C223.38 111.351 223.786 110.709 224.03 110H226C230.6 110.005 234.328 113.734 234.333 118.333V131.667Z"
                                        fill="#363636" />
                                    <path
                                        d="M276 66.6669H266V60C266 57.2388 263.761 55 261 55H237.667C234.905 55 232.667 57.2388 232.667 60V66.6669H222.667C219.905 66.6669 217.667 68.905 217.667 71.6669V75H221V71.6669C221 70.7465 221.746 70 222.667 70H276C276.92 70 277.667 70.7465 277.667 71.6669V85C277.667 85.9204 276.92 86.6669 276 86.6669H256V85C256 82.2388 253.761 80 251 80H247.667C244.905 80 242.667 82.2388 242.667 85V86.6669H232.667V90H242.667V91.6669C242.667 94.4281 244.905 96.6669 247.667 96.6669H251C253.761 96.6669 256 94.4281 256 91.6669V90H272.667V121.667C272.667 122.587 271.92 123.333 271 123.333H241V126.667H271C273.761 126.667 276 124.428 276 121.667V90C278.761 90 281 87.7612 281 85V71.6669C281 68.905 278.761 66.6669 276 66.6669ZM236 60C236 59.0796 236.746 58.3331 237.667 58.3331H261C261.92 58.3331 262.667 59.0796 262.667 60V66.6669H236V60ZM252.667 91.6669C252.667 92.5873 251.92 93.3331 251 93.3331H247.667C246.746 93.3331 246 92.5873 246 91.6669V85C246 84.0796 246.746 83.3331 247.667 83.3331H251C251.92 83.3331 252.667 84.0796 252.667 85V91.6669Z"
                                        fill="#363636" />
                                    <path d="M266 116.667H269.333V120H266V116.667Z" fill="#363636" />
                                    <path d="M266 110H269.333V113.333H266V110Z" fill="#363636" />
                                    <path d="M259.333 116.667H262.667V120H259.333V116.667Z" fill="#363636" />
                                </g>
                                <g clip-path="url(#clip3_445_10244)">
                                    <path
                                        d="M77.6669 111.667C75.8315 111.653 74.3472 110.168 74.3331 108.333H71C65.4769 108.333 61 112.811 61 118.333V133.333H94.3331V118.333C94.3331 112.811 89.8562 108.333 84.3331 108.333H81C80.9945 110.172 79.5052 111.661 77.6669 111.667Z"
                                        fill="#C8C8C8" />
                                    <path
                                        d="M74.3331 108.333C74.3472 110.168 75.8315 111.653 77.6669 111.667C79.5052 111.661 80.9945 110.172 81 108.333V104.316C78.8711 105.228 76.462 105.228 74.3331 104.316V108.333Z"
                                        fill="white" />
                                    <path
                                        d="M69.3331 93.3331V96.6669C69.3411 99.9811 71.3009 102.98 74.3331 104.316C76.462 105.228 78.8711 105.228 81 104.816L83.5665 102.567C85.1254 100.999 86 98.8776 86 96.6669V93.3331C84.6652 93.3618 83.3767 92.8442 82.4331 91.9C81.4889 90.9564 80.9713 89.668 81 88.3331C81 88.3331 81 93.3331 69.3331 93.3331Z"
                                        fill="white" />
                                    <path
                                        d="M69.3331 88.3331V93.3331C81 93.3331 81 88.3331 81 88.3331C80.9713 89.668 81.4889 90.9564 82.4331 91.9C83.3767 92.8442 84.6652 93.3618 86 93.3331V88.3331C86 83.7311 82.2689 80 77.6669 80C73.0642 80 69.3331 83.7311 69.3331 88.3331Z"
                                        fill="#C8C8C8" />
                                    <path
                                        d="M26 125H61V118.333C61 112.811 65.4769 108.333 71 108.333H74.3331V104.316C71.3009 102.98 69.3411 99.9811 69.3331 96.6669V88.3331H52.6669V91.6669C52.6614 93.5052 51.1721 94.9945 49.3331 95H46C44.1616 94.9945 42.6724 93.5052 42.6669 91.6669V88.3331H22.6669V121.667C22.6724 123.505 24.1616 124.995 26 125Z"
                                        fill="white" />
                                    <path
                                        d="M42.6669 88.3331V91.6669C42.6724 93.5052 44.1616 94.9945 46 95H49.3331C51.1721 94.9945 52.6614 93.5052 52.6669 91.6669V85C52.6614 83.6616 51.1721 82.1724 49.3331 82.1669H46C44.1616 82.1724 42.6724 83.6616 42.6669 85V88.3331Z"
                                        fill="#C8C8C8" />
                                    <path
                                        d="M17.6669 71.6669V85C17.6724 86.8384 19.1616 88.3276 21 88.3331H42.6669V85C42.6724 83.1616 44.1616 81.6724 46 81.6669H49.3331C51.1721 81.6724 52.6614 83.6616 52.6669 85V88.3331H69.3331C69.3331 83.7311 73.0642 80 77.6669 80V71.6669C77.6614 69.8279 76.1721 68.3386 74.3331 68.3331H21C19.1616 68.3386 17.6724 69.8279 17.6669 71.6669Z"
                                        fill="white" />
                                    <path
                                        d="M71 106.667H72.6669V105.312C69.5822 103.524 67.6785 100.232 67.6669 96.6669V88.3331C67.6669 82.8107 72.1438 78.3331 77.6669 78.3331C83.1893 78.3331 87.6669 82.8107 87.6669 88.3331V96.6669C87.6705 99.317 86.6219 101.86 84.7518 103.738C84.6768 103.814 84.5944 103.883 84.5065 103.943L82.6736 105.197V106.667H84.3331C90.7736 106.674 95.9927 111.893 96 118.333V133.333C96 134.254 95.2535 135 94.3331 135H61C60.0796 135 59.3331 134.254 59.3331 133.333V118.333C59.3405 111.893 64.5596 106.674 71 106.667ZM76.5103 109.521C76.8154 109.831 77.2323 110.003 77.6669 110C78.5873 110 79.3331 109.254 79.3331 108.333V106.517C78.2314 106.717 77.1023 106.717 76 106.517V108.333C75.9988 108.783 76.1837 109.213 76.5103 109.521ZM77.6669 81.6669C73.9846 81.6669 71 84.6515 71 88.3331V91.6302C78.868 91.2653 79.3331 88.3331 79.3331 88.3331C79.3331 87.4127 80.0796 86.6669 81 86.6669C81.9204 86.6669 82.6669 87.4127 82.6669 88.3331C82.5491 89.5673 83.215 90.7428 84.3331 91.2769V88.3331C84.3331 84.6515 81.3485 81.6669 77.6669 81.6669ZM84.3331 94.79C82.7847 94.4354 81.4163 93.5339 80.4781 92.2516C78.8418 93.5651 75.9786 94.7516 71 94.9652V96.6669C71.0067 99.3134 72.568 101.709 74.9868 102.783C76.6494 103.492 78.525 103.513 80.2035 102.842L82.488 101.285C83.674 100.04 84.3344 98.3862 84.3331 96.6669V94.79ZM62.6669 131.667H92.6669V118.333C92.6614 113.734 88.9333 110.005 84.3331 110H82.3599C81.8557 111.412 80.7449 112.523 79.3331 113.027V126.667H76V113.032C75.3036 112.795 74.6713 112.399 74.1531 111.877C73.6196 111.351 73.2144 110.709 72.9702 110H71C66.3998 110.005 62.6724 113.734 62.6669 118.333V131.667Z"
                                        fill="#363636" />
                                    <path
                                        d="M21 66.6669H31V60C31 57.2388 33.2388 55 36 55H59.3331C62.095 55 64.3331 57.2388 64.3331 60V66.6669H74.3331C77.095 66.6669 79.3331 68.905 79.3331 71.6669V75H76V71.6669C76 70.7465 75.2535 70 74.3331 70H21C20.0796 70 19.3331 70.7465 19.3331 71.6669V85C19.3331 85.9204 20.0796 86.6669 21 86.6669H41V85C41 82.2388 43.2388 80 46 80H49.3331C52.095 80 54.3331 82.2388 54.3331 85V86.6669H64.3331V90H54.3331V91.6669C54.3331 94.4281 52.095 96.6669 49.3331 96.6669H46C43.2388 96.6669 41 94.4281 41 91.6669V90H24.3331V121.667C24.3331 122.587 25.0796 123.333 26 123.333H56V126.667H26C23.2388 126.667 21 124.428 21 121.667V90C18.2388 90 16 87.7612 16 85V71.6669C16 68.905 18.2388 66.6669 21 66.6669ZM61 60C61 59.0796 60.2535 58.3331 59.3331 58.3331H36C35.0796 58.3331 34.3331 59.0796 34.3331 60V66.6669H61V60ZM44.3331 91.6669C44.3331 92.5873 45.0796 93.3331 46 93.3331H49.3331C50.2535 93.3331 51 92.5873 51 91.6669V85C51 84.0796 50.2535 83.3331 49.3331 83.3331H46C45.0796 83.3331 44.3331 84.0796 44.3331 85V91.6669Z"
                                        fill="#363636" />
                                    <path d="M31 116.667H27.6669V120H31V116.667Z" fill="#363636" />
                                    <path d="M31 110H27.6669V113.333H31V110Z" fill="#363636" />
                                    <path d="M37.6669 116.667H34.3331V120H37.6669V116.667Z" fill="#363636" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_445_10244">
                                        <rect width="40" height="40" fill="white" transform="translate(101 48)" />
                                    </clipPath>
                                    <clipPath id="clip1_445_10244">
                                        <rect width="40" height="40" fill="white" transform="translate(157 48)" />
                                    </clipPath>
                                    <clipPath id="clip2_445_10244">
                                        <rect width="80" height="80" fill="white" transform="translate(201 55)" />
                                    </clipPath>
                                    <clipPath id="clip3_445_10244">
                                        <rect width="80" height="80" fill="white" transform="matrix(-1 0 0 1 96 55)" />
                                    </clipPath>
                                </defs>
                            </svg>


                        </div>
                        }
                        @if(!UserIndicators.length && UserProjects.length){

                        <div>
                            <svg width="297" height="144" viewBox="0 0 297 144" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect y="0.5" width="297" height="143" rx="8" fill="white" />
                                <path
                                    d="M147.959 16.9321C147.125 16.9332 146.309 16.6868 145.615 16.2239C144.92 15.7611 144.379 15.1027 144.059 14.3321C143.74 13.5615 143.656 12.7133 143.818 11.8949C143.981 11.0766 144.382 10.3248 144.972 9.73484C145.562 9.14487 146.314 8.74323 147.132 8.58073C147.951 8.41824 148.799 8.50222 149.569 8.82203C150.34 9.14184 150.998 9.6831 151.461 10.3773C151.924 11.0715 152.171 11.8874 152.169 12.7218C152.169 13.8384 151.726 14.9093 150.936 15.6989C150.147 16.4885 149.076 16.9321 147.959 16.9321Z"
                                    fill="#949494" />
                                <path
                                    d="M130.968 18.5186C130.134 18.5197 129.318 18.2733 128.624 17.8104C127.929 17.3476 127.388 16.6892 127.068 15.9186C126.748 15.148 126.664 14.2998 126.827 13.4814C126.989 12.6631 127.391 11.9113 127.981 11.3213C128.571 10.7314 129.323 10.3297 130.141 10.1672C130.96 10.0047 131.808 10.0887 132.578 10.4085C133.349 10.7283 134.007 11.2696 134.47 11.9638C134.933 12.658 135.179 13.4739 135.178 14.3083C135.178 15.4249 134.735 16.4958 133.945 17.2854C133.156 18.075 132.085 18.5186 130.968 18.5186Z"
                                    fill="#949494" />
                                <path
                                    d="M114.523 23.038C116.851 23.038 118.739 21.1504 118.739 18.822C118.739 16.4935 116.851 14.6059 114.523 14.6059C112.194 14.6059 110.307 16.4935 110.307 18.822C110.307 21.1504 112.194 23.038 114.523 23.038Z"
                                    fill="#949494" />
                                <path
                                    d="M99.1132 30.3478C98.2789 30.3489 97.4629 30.1025 96.7687 29.6397C96.0745 29.1768 95.5333 28.5184 95.2134 27.7478C94.8936 26.9772 94.8097 26.129 94.9722 25.3107C95.1346 24.4923 95.5363 23.7405 96.1263 23.1506C96.7162 22.5606 97.468 22.1589 98.2864 21.9964C99.1047 21.8339 99.9529 21.9179 100.724 22.2377C101.494 22.5576 102.153 23.0988 102.615 23.793C103.078 24.4872 103.325 25.3031 103.323 26.1375C103.323 26.6904 103.215 27.2379 103.003 27.7487C102.791 28.2595 102.481 28.7237 102.09 29.1146C101.699 29.5056 101.235 29.8157 100.724 30.0273C100.214 30.2389 99.6661 30.3478 99.1132 30.3478Z"
                                    fill="#949494" />
                                <path
                                    d="M85.2049 40.2001C87.5333 40.2001 89.4209 38.3125 89.4209 35.984C89.4209 33.6556 87.5333 31.768 85.2049 31.768C82.8764 31.768 80.9888 33.6556 80.9888 35.984C80.9888 38.3125 82.8764 40.2001 85.2049 40.2001Z"
                                    fill="#949494" />
                                <path
                                    d="M73.216 52.3274C72.3822 52.3274 71.5671 52.0802 70.8737 51.6169C70.1804 51.1536 69.64 49.9952 69.3209 49.2248C69.0018 48.4544 68.9183 47.6067 69.081 46.7889C69.2437 45.971 69.6452 45.2198 70.2349 44.6302C70.8245 44.0406 71.5757 43.639 72.3935 43.4763C73.2114 43.3137 74.0591 43.3972 74.8295 43.7163C75.5998 44.0354 76.2583 44.5757 76.7216 45.2691C77.1848 45.9624 77.4321 46.7775 77.4321 47.6114C77.4329 48.1653 77.3243 48.7138 77.1127 49.2257C76.9011 49.7375 76.5906 50.2026 76.1989 50.5943C75.8073 50.9859 75.3422 51.2964 74.8304 51.508C74.3185 51.7196 73.7699 51.8282 73.216 51.8274Z"
                                    fill="#949494" />
                                <path
                                    d="M223.097 51.4335C225.425 51.4335 227.313 49.5459 227.313 47.2174C227.313 44.889 225.425 43.0014 223.097 43.0014C220.768 43.0014 218.881 44.889 218.881 47.2174C218.881 49.5459 220.768 51.4335 223.097 51.4335Z"
                                    fill="#949494" />
                                <path
                                    d="M210.965 39.4499C213.293 38.9499 215.181 37.0623 215.181 34.7339C215.181 32.4054 213.293 30.5178 210.965 30.5178C208.636 30.5178 206.749 32.4054 206.749 34.7339C206.749 37.0623 208.636 38.9499 210.965 38.9499Z"
                                    fill="#949494" />
                                <path
                                    d="M196.935 29.775C196.102 29.775 195.286 29.5277 194.593 29.0644C193.9 28.6012 193.359 27.9427 193.04 27.1723C192.721 26.4019 192.638 25.5542 192.8 24.7364C192.963 23.9186 193.365 23.1673 193.954 22.5777C194.544 21.9881 195.295 21.5866 196.113 21.4239C196.931 21.2612 197.778 21.3447 198.549 21.6638C199.319 21.9829 199.978 22.5233 200.441 23.2166C200.904 23.9099 201.151 24.7251 201.151 25.5589C201.151 26.6771 200.707 27.7494 199.917 28.5401C199.126 29.3308 198.054 29.775 196.935 29.775Z"
                                    fill="#949494" />
                                <path
                                    d="M181.441 22.6375C183.77 22.6375 185.657 20.7499 185.657 17.9214C185.657 15.593 183.77 13.7054 181.441 13.7054C179.113 13.7054 177.225 15.593 177.225 17.9214C177.225 20.2499 179.113 22.1375 181.441 22.1375Z"
                                    fill="#949494" />
                                <path
                                    d="M164.943 17.8183C164.109 17.8195 163.293 17.5732 162.599 17.1106C161.905 16.648 161.364 15.99 161.044 15.2197C160.724 14.4494 160.64 13.6015 160.802 12.7833C160.964 11.9651 161.365 11.2133 161.954 10.6231C162.544 10.0329 163.295 9.6308 164.113 9.46766C164.931 9.30452 165.779 9.38768 166.549 9.70662C167.32 10.0255 167.979 10.5659 168.442 11.2594C168.906 11.9528 169.153 12.7682 169.153 13.6023C169.153 14.7195 168.71 15.7909 167.921 16.5814C167.131 17.3719 166.06 17.8168 164.943 17.8183Z"
                                    fill="#949494" />
                                <g clip-path="url(#clip0_445_10374)">
                                    <path
                                        d="M219.333 112.167C221.168 112.153 222.653 110.668 222.667 108.833H226C231.523 108.833 236 113.311 236 118.833V133.833H202.667V118.833C202.667 113.311 207.144 108.833 212.667 108.833H216C216.005 110.672 217.495 112.161 219.333 112.167Z"
                                        fill="#C8C8C8" />
                                    <path
                                        d="M222.667 108.833C222.653 110.668 221.168 112.153 219.333 112.167C217.495 112.161 216.005 110.672 216 108.833V104.816C218.129 105.728 220.538 105.728 222.667 104.816V108.833Z"
                                        fill="white" />
                                    <path
                                        d="M227.667 93.8331V97.1669C227.659 100.481 225.699 103.48 222.667 104.816C220.538 105.728 218.129 105.728 216 104.816L213.433 103.067C211.875 101.499 211 99.3776 211 97.1669V93.3331C212.335 93.3618 213.623 92.8442 214.567 91.9C215.511 90.9564 216.029 89.668 216 88.3331C216 88.3331 216 93.3331 227.667 93.3331Z"
                                        fill="white" />
                                    <path
                                        d="M227.667 88.3331V93.3331C216 93.3331 216 88.3331 216 88.3331C216.029 90.168 215.511 91.4564 214.567 92.4C213.623 93.3442 212.335 93.8618 211 93.8331V88.3331C211 83.7311 214.731 80.5 219.333 80.5C223.936 80.5 227.667 84.2311 227.667 88.3331Z"
                                        fill="#C8C8C8" />
                                    <path
                                        d="M271 125.5H236V118.833C236 112.811 231.523 108.333 226 108.333H222.667V104.316C225.699 102.98 227.659 99.9811 227.667 96.6669V88.3331H244.333V91.6669C244.339 93.5052 245.828 94.9945 247.667 95H251C252.838 94.9945 254.328 93.5052 254.333 91.6669V88.3331H274.333V121.667C274.328 123.505 272.838 124.995 271 125.5Z"
                                        fill="white" />
                                    <path
                                        d="M254.333 88.3331V92.1669C254.328 94.0052 252.838 95.4945 251 95.5H247.667C245.828 95.4945 244.339 94.0052 244.333 92.1669V85.5C244.339 83.6616 245.828 82.1724 247.667 82.1669H251C252.838 82.1724 254.328 83.6616 254.333 85V88.3331Z"
                                        fill="#C8C8C8" />
                                    <path
                                        d="M279.333 72.1669V85C279.328 86.8384 277.838 88.3276 276 88.3331H254.333V85C254.328 83.1616 252.838 81.6724 251 82.1669H247.667C245.828 82.1724 244.339 83.6616 244.333 85V88.3331H227.667C227.667 84.2311 223.936 80.5 219.333 80.5V72.1669C219.339 70.3279 220.828 68.8386 222.667 68.3331H276C277.838 68.3386 279.328 69.8279 279.333 71.6669Z"
                                        fill="white" />
                                    <path
                                        d="M226 107.167H224.333V105.312C227.418 103.524 229.322 100.232 229.333 96.6669V88.3331C229.333 82.8107 224.856 78.3331 219.333 78.3331C213.811 78.3331 209.333 82.8107 209.333 88.3331V96.6669C209.329 99.317 210.378 101.86 212.248 103.738C212.323 103.814 212.406 103.883 212.494 103.943L214.326 105.197V106.667H212.667C206.226 106.674 201.007 111.893 201 118.333V133.333C201 134.254 201.746 135 202.667 135H236C236.92 135 237.667 134.254 237.667 133.333V118.333C237.66 111.893 232.44 106.674 226 106.667ZM220.49 109.521C220.185 109.831 219.768 110.003 219.333 110C218.413 110 217.667 109.254 217.667 108.333V106.517C218.769 106.717 219.898 106.717 221 106.517V108.333C221.001 108.783 220.816 109.213 220.49 109.521ZM219.333 81.6669C223.015 81.6669 226 84.6515 226 88.3331V91.6302C218.132 91.2653 217.667 88.3331 217.667 88.3331C217.667 87.4127 216.92 86.6669 216 86.6669C215.08 86.6669 214.333 87.4127 214.333 88.3331C214.451 89.5673 213.785 90.7428 212.667 91.2769V88.3331C212.667 84.6515 215.651 81.6669 219.333 81.6669ZM212.667 94.79C214.215 94.4354 215.584 93.5339 216.522 92.2516C218.158 93.5651 221.021 94.7516 226 94.9652V96.6669C225.993 99.3134 224.432 101.709 222.013 102.783C220.351 103.492 218.475 103.513 216.797 102.842L214.512 101.285C213.326 100.04 212.666 98.3862 212.667 96.6669V94.79ZM234.333 132.167H204.333V118.333C204.339 113.734 208.067 110.005 212.667 110H214.64C215.144 111.412 216.255 112.523 217.667 113.027V126.667H221V113.032C221.696 112.795 222.329 112.399 222.847 111.877C223.38 111.351 223.786 110.709 224.03 110H226C230.6 110.005 234.328 113.734 234.333 118.333V131.667Z"
                                        fill="#363636" />
                                    <path
                                        d="M276 66.6669H266V60C266 57.2388 263.761 55 261 55H237.667C234.905 55 232.667 57.2388 232.667 60V66.6669H222.667C219.905 66.6669 217.667 68.905 217.667 71.6669V75H221V71.6669C221 70.7465 221.746 70 222.667 70H276C276.92 70 277.667 70.7465 277.667 71.6669V85C277.667 85.9204 276.92 86.6669 276 86.6669H256V85C256 82.2388 253.761 80 251 80H247.667C244.905 80 242.667 82.2388 242.667 85V86.6669H232.667V90H242.667V91.6669C242.667 94.4281 244.905 96.6669 247.667 96.6669H251C253.761 96.6669 256 94.4281 256 91.6669V90H272.667V121.667C272.667 122.587 271.92 123.333 271 123.333H241V126.667H271C273.761 126.667 276 124.428 276 121.667V90C278.761 90 281 87.7612 281 85V71.6669C281 68.905 278.761 66.6669 276 66.6669ZM236 60C236 59.0796 236.746 58.3331 237.667 58.3331H261C261.92 58.3331 262.667 59.0796 262.667 60V66.6669H236V60ZM252.667 91.6669C252.667 92.5873 251.92 93.3331 251 93.3331H247.667C246.746 93.3331 246 92.5873 246 91.6669V85C246 84.0796 246.746 83.3331 247.667 83.3331H251C251.92 83.3331 252.667 84.0796 252.667 85V91.6669Z"
                                        fill="#363636" />
                                    <path d="M266 116.667H269.333V120H266V116.667Z" fill="#363636" />
                                    <path d="M266 110H269.333V113.333H266V110Z" fill="#363636" />
                                    <path d="M259.333 116.667H262.667V120H259.333V116.667Z" fill="#363636" />
                                </g>
                                <g clip-path="url(#clip1_445_10374)">
                                    <path
                                        d="M77.6669 112.167C75.8315 112.153 74.3472 110.668 74.3331 108.833H71C65.4769 108.333 61 112.811 61 118.333V133.333H94.3331V118.333C94.3331 112.811 89.8562 108.333 84.3331 108.333H81C80.9945 110.172 79.5052 111.661 77.6669 111.667Z"
                                        fill="#C8C8C8" />
                                    <path
                                        d="M74.3331 108.833C74.3472 110.668 75.8315 112.153 77.6669 112.167C79.5052 111.661 80.9945 110.172 81 108.333V104.316C78.8711 105.228 76.462 105.228 74.3331 104.316V108.333Z"
                                        fill="white" />
                                    <path
                                        d="M69.3331 93.8331V97.1669C69.3411 100.481 71.3009 103.48 74.3331 104.816C76.462 105.728 78.8711 105.728 81 104.816L83.5665 102.567C85.1254 100.999 86 98.8776 86 96.6669V93.3331C84.6652 93.3618 83.3767 92.8442 82.4331 91.9C81.4889 90.9564 80.9713 89.668 81 88.3331C81 88.3331 81 93.3331 69.3331 93.3331Z"
                                        fill="white" />
                                    <path
                                        d="M69.3331 88.3331V93.3331C81 93.3331 81 88.3331 81 88.3331C80.9713 89.668 81.4889 90.9564 82.4331 91.9C83.3767 92.8442 84.6652 93.3618 86 93.3331V88.3331C86 83.7311 82.2689 80 77.6669 80C73.0642 80 69.3331 83.7311 69.3331 88.3331Z"
                                        fill="#C8C8C8" />
                                    <path
                                        d="M26 125.5H61V118.833C61 112.811 65.4769 108.333 71 108.333H74.3331V104.316C71.3009 102.98 69.3411 99.9811 69.3331 96.6669V88.3331H52.6669V91.6669C52.6614 93.5052 51.1721 94.9945 49.3331 95H46C44.1616 94.9945 42.6724 93.5052 42.6669 91.6669V88.3331H22.6669V121.667C22.6724 123.505 24.1616 124.995 26 125.5Z"
                                        fill="white" />
                                    <path
                                        d="M42.6669 88.3331V91.6669C42.6724 93.5052 44.1616 94.9945 46 95H49.3331C51.1721 94.9945 52.6614 93.5052 52.6669 91.6669V85C52.6614 83.6616 51.1721 82.1724 49.3331 82.1669H46C44.1616 82.1724 42.6724 83.6616 42.6669 85V88.3331Z"
                                        fill="#C8C8C8" />
                                    <path
                                        d="M17.6669 72.1669V85C17.6724 86.8384 19.1616 88.3276 21 88.3331H42.6669V85C42.6724 83.1616 44.1616 81.6724 46 81.6669H49.3331C51.1721 81.6724 52.6614 83.6616 52.6669 85V88.3331H69.3331C69.3331 83.7311 73.0642 80 77.6669 80V71.6669C77.6614 69.8279 76.1721 68.3386 74.3331 68.3331H21C19.1616 68.3386 17.6724 69.8279 17.6669 71.6669Z"
                                        fill="white" />
                                    <path
                                        d="M71 107.167H72.6669V105.312C69.5822 103.524 67.6785 100.232 67.6669 96.6669V88.3331C67.6669 82.8107 72.1438 78.3331 77.6669 78.3331C83.1893 78.3331 87.6669 82.8107 87.6669 88.3331V96.6669C87.6705 99.317 86.6219 101.86 84.7518 103.738C84.6768 103.814 84.5944 103.883 84.5065 103.943L82.6736 105.197V106.667H84.3331C90.7736 106.674 95.9927 111.893 96 118.333V133.333C96 134.254 95.2535 135 94.3331 135H61C60.0796 135 59.3331 134.254 59.3331 133.333V118.333C59.3405 111.893 64.5596 106.674 71 106.667ZM76.5103 109.521C76.8154 109.831 77.2323 110.003 77.6669 110C78.5873 110 79.3331 109.254 79.3331 108.333V106.517C78.2314 106.717 77.1023 106.717 76 106.517V108.333C75.9988 108.783 76.1837 109.213 76.5103 109.521ZM77.6669 81.6669C73.9846 81.6669 71 84.6515 71 88.3331V91.6302C78.868 91.2653 79.3331 88.3331 79.3331 88.3331C79.3331 87.4127 80.0796 86.6669 81 86.6669C81.9204 86.6669 82.6669 87.4127 82.6669 88.3331C82.5491 89.5673 83.215 90.7428 84.3331 91.2769V88.3331C84.3331 84.6515 81.3485 81.6669 77.6669 81.6669ZM84.3331 94.79C82.7847 94.4354 81.4163 93.5339 80.4781 92.2516C78.8418 93.5651 75.9786 94.7516 71 94.9652V96.6669C71.0067 99.3134 72.568 101.709 74.9868 102.783C76.6494 103.492 78.525 103.513 80.2035 102.842L82.488 101.285C83.674 100.04 84.3344 98.3862 84.3331 96.6669V94.79ZM62.6669 131.667H92.6669V118.333C92.6614 113.734 88.9333 110.005 84.3331 110H82.3599C81.8557 111.412 80.7449 112.523 79.3331 113.027V126.667H76V113.032C75.3036 112.795 74.6713 112.399 74.1531 111.877C73.6196 111.351 73.2144 110.709 72.9702 110H71C66.3998 110.005 62.6724 113.734 62.6669 118.333V131.667Z"
                                        fill="#363636" />
                                    <path
                                        d="M21 66.6669H31V60C31 57.2388 33.2388 55 36 55H59.3331C62.095 55 64.3331 57.2388 64.3331 60V66.6669H74.3331C77.095 66.6669 79.3331 68.905 79.3331 71.6669V75H76V71.6669C76 70.7465 75.2535 70 74.3331 70H21C20.0796 70 19.3331 70.7465 19.3331 71.6669V85C19.3331 85.9204 20.0796 86.6669 21 86.6669H41V85C41 82.2388 43.2388 80 46 80H49.3331C52.095 80 54.3331 82.2388 54.3331 85V86.6669H64.3331V90H54.3331V91.6669C54.3331 94.4281 52.095 96.6669 49.3331 96.6669H46C43.2388 96.6669 41 94.4281 41 91.6669V90H24.3331V121.667C24.3331 122.587 25.0796 123.333 26 123.333H56V126.667H26C23.2388 126.667 21 124.428 21 121.667V90C18.2388 90 16 87.7612 16 85V71.6669C16 68.905 18.2388 66.6669 21 66.6669ZM61 60C61 59.0796 60.2535 58.3331 59.3331 58.3331H36C35.0796 58.3331 34.3331 59.0796 34.3331 60V66.6669H61V60ZM44.3331 91.6669C44.3331 92.5873 45.0796 93.3331 46 93.3331H49.3331C50.2535 93.3331 51 92.5873 51 91.6669V85C51 84.0796 50.2535 83.3331 49.3331 83.3331H46C45.0796 83.3331 44.3331 84.0796 44.3331 85V91.6669Z"
                                        fill="#363636" />
                                    <path d="M31 116.667H27.6669V120H31V116.667Z" fill="#363636" />
                                    <path d="M31 110H27.6669V113.333H31V110Z" fill="#363636" />
                                    <path d="M37.6669 116.667H34.3331V120H37.6669V116.667Z" fill="#363636" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_445_10374">
                                        <rect width="80" height="80" fill="white" transform="translate(201 55.5)" />
                                    </clipPath>
                                    <clipPath id="clip1_445_10374">
                                        <rect width="80" height="80" fill="white"
                                            transform="matrix(-1 0 0 1 96 55.5)" />
                                    </clipPath>
                                </defs>
                            </svg>

                        </div>
                        }
                        @if(!UserIndicators.length && UserProjects.length){
                        <form [formGroup]="userProjectsForm" (ngSubmit)="onProjectTransferSubmit()">
                            <div class="mb-3 text-center font-bold">{{'initiative'|translate}}
                                {{"until_date" | translate}}
                                {{today | date:'fullDate'}}
                            </div>
                            <p-table [class]="dir" rowGroupMode="rowspan" groupRowsBy="strategy_name" [value]="UserProjects"
                                [tableStyle]="{ 'min-width': '50rem' }">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>
                                            {{'strategy'|translate}}
                                        </th>
                                        <th>
                                            {{'initiative_name'|translate}}
                                        </th>
                                        <th>
                                            {{'department'|translate}}
                                        </th>
                                        <th>
                                            {{'execution_supervisor'|translate}}
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowgroup="rowgroup" let-rowspan="rowspan" let-item
                                    let-rowIndex="rowIndex">

                                    <tr [formGroupName]="rowIndex">

                                        <td *ngIf="rowgroup" [attr.rowspan]="rowspan">
                                            {{item.strategy_name}}
                                        </td>
                                        <td>
                                            {{item.name}}
                                        </td>
                                        <td>
                                            <div class="my-2 text-gray-500">
                                                {{item.in_charge_unit_name}}
                                            </div>
                                            <p-dropdown filterBy="name" [filter]="true" formControlName="entity_in_charge_id"
                                                appendTo="body" ngClass="drop" [options]="item.inChargeUnits" optionLabel="name"
                                                optionValue="value" placeholder="{{'choose'|translate}}" />
                                        </td>
                                        <td>
                                            <div class="my-2 text-gray-500">

                                                {{item.in_charge_name}}
                                            </div>
                                            <p-dropdown formControlName="executive_in_charge_id" appendTo="body" ngClass="drop"
                                                [options]="item.filteredInChargeExecutives" optionLabel="name" optionValue="id"
                                                placeholder="{{'choose'|translate}}" />
                                        </td>
                                    </tr>

                                </ng-template>
                            </p-table>
                            <div class="flex flex-column align-items-center gap-3  mt-5">
                                <div class="bg-yellow-500 w-fit p-2 border-round-lg">
                                    {{"to_save_changes_all_indicators_must_be_transferred"|translate}}
                                </div>
                                <p-button [disabled]="!userIndicatorForm.valid" type="submit">
                                    {{'save_changes'|translate}}</p-button>
                            </div>
                        </form>
                        }

                        @if(!UserIndicators.length && !UserProjects.length){
                        <div class="flex flex-column align-items-center gap-2">

                            <div class="font-bold">{{'no_indicators'|translate}}</div>
                            <div class="font-bold"> {{'no_initiatives'|translate}}</div>
                            <p-button severity="danger" (onClick)="confirmUserDelete($event,selectedUserId)">حذف
                                {{currentUserDeletionPreview?.user?.name}}
                            </p-button>
                        </div>
                        }

                    </div>





                </div>

                @if(UserIndicators.length){

                <form [formGroup]="userIndicatorForm" (ngSubmit)="onIndiactorTransferSubmit()">
                    <div class="mb-3 text-center font-bold">مؤشرات {{currentUserDeletionPreview?.user?.name}}
                        {{'until_date' | translate}}
                        {{today | date:'fullDate'}}</div>
                    <p-table [class]="dir" rowGroupMode="rowspan" groupRowsBy="strategy_name" [value]="UserIndicators"
                        [tableStyle]="{ 'min-width': '50rem' }">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>
                                    {{'strategy'|translate}}
                                </th>
                                <th>
                                    {{'indicator'|translate}}
                                </th>
                                <th>
                                    {{'officer'|translate}}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowgroup="rowgroup" let-rowspan="rowspan" let-item
                            let-rowIndex="rowIndex">

                            <tr [formGroupName]="rowIndex">

                                <td *ngIf="rowgroup" [attr.rowspan]="rowspan">
                                    {{item.strategy_name}}
                                </td>
                                <td>
                                    {{item.name}}

                                </td>
                                <td>
                                    <div class="my-2 text-gray-500">

                                        {{item.in_charge_name}}
                                    </div>
                                    <p-dropdown filter="true" filterBy="name" formControlName="in_charge_id"
                                        appendTo="body" ngClass="drop" [options]="item.filteredInChargeExecutives"
                                        optionLabel="name" optionValue="id" placeholder="{{'choose'|translate}}" />
                                </td>
                            </tr>

                        </ng-template>
                    </p-table>
                    <div class="flex flex-column align-items-center gap-3  mt-5">
                        <div class="bg-yellow-500 w-fit p-2 border-round-lg">
                            {{"to_save_changes_all_indicators_must_be_transferred"|translate}}
                        </div>
                        <p-button [disabled]="!userIndicatorForm.valid"
                            type="submit">{{'save_changes'|translate}}</p-button>
                    </div>
                </form>
                }
                @if(!UserIndicators.length && UserProjects.length){
                <form [formGroup]="userProjectsForm" (ngSubmit)="onProjectTransferSubmit()">
                    <div class="mb-3 text-center font-bold">{{'initiative'|translate}}
                        {{"until_date" | translate}}
                        {{today | date:'fullDate'}}
                    </div>
                    <p-table [class]="dir" rowGroupMode="rowspan" groupRowsBy="strategy_name" [value]="UserProjects"
                        [tableStyle]="{ 'min-width': '50rem' }">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>
                                    {{'strategy'|translate}}
                                </th>
                                <th>
                                    {{'initiative_name'|translate}}
                                </th>
                                <th>
                                    {{'department'|translate}}
                                </th>
                                <th>
                                    {{'execution_supervisor'|translate}}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowgroup="rowgroup" let-rowspan="rowspan" let-item
                            let-rowIndex="rowIndex">

                            <tr [formGroupName]="rowIndex">

                                <td *ngIf="rowgroup" [attr.rowspan]="rowspan">
                                    {{item.strategy_name}}
                                </td>
                                <td>
                                    {{item.name}}
                                </td>
                                <td>
                                    <div class="my-2 text-gray-500">
                                        {{item.in_charge_unit_name}}
                                    </div>
                                    <p-dropdown filterBy="name" [filter]="true" formControlName="entity_in_charge_id"
                                        appendTo="body" ngClass="drop" [options]="item.inChargeUnits" optionLabel="name"
                                        optionValue="value" placeholder="{{'choose'|translate}}" />
                                </td>
                                <td>
                                    <div class="my-2 text-gray-500">

                                        {{item.in_charge_name}}
                                    </div>
                                    <p-dropdown formControlName="executive_in_charge_id" appendTo="body" ngClass="drop"
                                        [options]="item.filteredInChargeExecutives" optionLabel="name" optionValue="id"
                                        placeholder="{{'choose'|translate}}" />
                                </td>
                            </tr>

                        </ng-template>
                    </p-table>
                    <div class="flex flex-column align-items-center gap-3  mt-5">
                        <div class="bg-yellow-500 w-fit p-2 border-round-lg">
                            {{"to_save_changes_all_indicators_must_be_transferred"|translate}}
                        </div>
                        <p-button [disabled]="!userIndicatorForm.valid" type="submit">
                            {{'save_changes'|translate}}</p-button>
                    </div>
                </form>
                }

                @if(!UserIndicators.length && !UserProjects.length){
                <div class="flex flex-column align-items-center gap-2">

                    <div class="font-bold">{{'no_indicators'|translate}}</div>
                    <div class="font-bold"> {{'no_initiatives'|translate}}</div>
                    <p-button severity="danger" (onClick)="confirmUserDelete($event,selectedUserId)">حذف
                        {{currentUserDeletionPreview?.user?.name}}
                    </p-button>
                </div>
                }

            </div>
        </div>
        <div class="g-overlay"></div>
    </div>
    }




    <p-confirmPopup #confirmPopupRef>
        <ng-template pTemplate="headless" let-message let-test>
            <div class="border-round p-3">
                <span>{{ message.message }}</span>
                <div class="flex align-items-center gap-2 mt-3">
                    <p-button i18n-label (click)="accept()" i18n-label label="{{'yes'|translate}}"
                        severity="danger"></p-button>
                    <p-button i18n-label (click)="reject()" i18n-label label="{{'no'|translate}}"
                        severity="secondary"></p-button>
                </div>
            </div>
        </ng-template>
    </p-confirmPopup>
</div>
